(function () {
  'use strict'

  require('./scss/ugc-page.scss')
  require('dynamic-bind-html') // ಠ_ಠ

  const MODULE_NAME = 'thismoment.glow.component.module.ugc.component.page'
  const templateUrl = require('./tpl/ugc-page.html')

  require('angular')
    .module(MODULE_NAME, [
      require('../../../../../../common/filter/trustHtml'),
      require('../../provider/ugc-api')
    ])
    .component('thismomentGlowModuleUgcPage', {
      templateUrl: templateUrl,
      bindings: {
        moduleId: '<',
        name: '<'
      },
      controller: glowUgcController
    })

  glowUgcController.$inject = ['$window', '$rootScope', '$scope', '$element', 'GlowConfig', 'analyticsSDK', 'UgcApi']
  function glowUgcController ($window, $rootScope, $scope, $element, GlowConfig, analyticsSDK, UgcApi) {
    const vm = this
    vm.$onInit = ugcInit

    function ugcInit () {
      const ugcModule = GlowConfig.getModule(vm.moduleId)

      if (!('get' in ugcModule) || ugcModule.get('type') !== 'module_ugc') {
        return
      }

      vm.trackEvent = analyticsSDK.setupEventTracking({
        'module title': ugcModule.get('name'),
        'module type': ugcModule.get('type').replace('module_', ''),
        'tm module id': ugcModule.get('id')
      })

      vm.onSubmit = onSubmit
      vm.onReset = onReset

      vm.formData = {}
      vm.ariaLabel = ugcModule.get('name')
      vm.autocomplete = ugcModule.get('submission_form_autocomplete') ? 'on' : 'off'
      vm.cancelBackgroundColor = ugcModule.get('cancel_button_color')
      vm.cancelColor = ugcModule.get('cancel_button_text_color')
      vm.cancelText = ugcModule.get('cancel_button_text')
      vm.errorButtonText = ugcModule.get('error_button_text')
      vm.errorColor = ugcModule.get('error_color')
      vm.errorDescription = ugcModule.get('error_description')
      vm.errorTitle = ugcModule.get('error_title')
      vm.fields = ugcModule.get('form_items')
      vm.limitReached = ugcModule.get('limit_reached')
      vm.limitReachedMessage = ugcModule.get('limit_reached_message')
      vm.processingDescription = ugcModule.get('processing_description')
      vm.processingTitle = ugcModule.get('processing_title')
      vm.submissionBackgroundColor = ugcModule.get('submission_background_color')
      vm.submissionBackgroundImage = ugcModule.get('submission_background_image')
      vm.submissionFormDescription = ugcModule.get('submission_form_description')
      vm.submissionFormDescriptionColor = ugcModule.get('submission_form_description_color')
      vm.submissionFormTitle = ugcModule.get('submission_form_title')
      vm.submissionFormTitleColor = ugcModule.get('submission_form_title_color')
      vm.submitBackgroundColor = ugcModule.get('submit_button_color')
      vm.submitColor = ugcModule.get('submit_button_text_color')
      vm.submitText = ugcModule.get('submit_button_text')
      vm.successButtonText = ugcModule.get('success_button_text')
      vm.successColor = ugcModule.get('success_color')
      vm.successDescription = ugcModule.get('success_description')
      vm.successTitle = ugcModule.get('success_title')

      vm.styles = {}
      if (vm.submissionFormDescription) {
        vm.styles.submissionFormDescription = {color: vm.submissionFormDescriptionColor}
      }
      if (vm.submissionFormTitle) {
        vm.styles.submissionFormTitle = {color: vm.submissionFormTitleColor}
      }
      if (vm.submissionBackgroundColor) {
        vm.styles.wrapper = {'background-color': vm.submissionBackgroundColor}
      }
      if (vm.successColor) {
        vm.styles.success = {
          button: {
            'background-color': vm.successColor,
            'border-color': vm.successColor
          },
          glyph: {
            color: vm.successColor
          }
        }
      }
      if (vm.errorColor) {
        vm.styles.error = {
          button: {
            'background-color': vm.errorColor,
            'border-color': vm.errorColor
          },
          glyph: {
            color: vm.errorColor
          }
        }
      }

      var checkHeightInterval = setInterval(function () {
        var height = $element[0].offsetHeight
        if (height !== 0) {
          vm.styles.wrapper.height = height.toString() + 'px'
          clearInterval(checkHeightInterval)
        }
      }, 1000)

      function onSubmit () {
        vm.busy = true
        UgcApi.send(vm.formData, ugcModule.get('id'), ugcModule.get('submission_playlist_id'))
          .then(function (response) {
            if ('status' in response && response.status !== 200) {
              throw new Error()
            }
            if ('limit_reached' in response) {
              vm.limitReached = true
            }
            if ('success' in response) {
              vm.success = true
              var analyticsProps = {
                'event trigger': 'submitted UGC submission',
                'content ids': response.content_ids
              }
              vm.trackEvent('Module Converted', analyticsProps)
            }
            vm.busy = false
          }).catch(function (error) {
            vm.busy = false
            vm.error = true
            console.warn(error)
          })
      }

      function onReset () {
        if (angular.isDefined($window.tmCallbacks) && angular.isFunction($window.tmCallbacks.continue)) {
          $window.tmCallbacks.continue()
        }
        $scope.$applyAsync(function () {
          vm.formData = {}
          $rootScope.$broadcast('formly:resetForm')
          vm.error = false
          vm.success = false
          vm.busy = false
        })
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-ugc/component/ugc-page/index.js